export default __webpack_public_path__ + "static/O0262-1c1a9b6a98dae8a16712ccd99048b7b9.png";